export default __webpack_public_path__ + "static/media/H1015.6.c30b1309.mp3";